/**
 * Created by Ibrahim Erata on 18.02.2017.
 */

/* config.service.ts */

import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {PaginationEvent} from "./PaginationEvent";


@Injectable()
export class PaginationService {

  public value: string;
  private eventOccuredSource:BehaviorSubject<PaginationEvent> = new BehaviorSubject<PaginationEvent>(new PaginationEvent("", true, true, false, "", false, ""));

  eventOccured$ = this.eventOccuredSource.asObservable();
  // service command
  action(event: PaginationEvent) {
    this.eventOccuredSource.next(event);
  }

  constructor() {
    this.value = "1";
  }

}
